<template>
  <div
    v-click-outside.capture="hide"
    class="notifications"
    @click="open"
  >
    <span class="notifications__icon">
      <i v-if="new_items_count > 0" class="notifications__counter">{{ new_items_count }}</i>
    </span>
    <div
      class="notifications__box"
      :class="{ 'notifications__box--active': is_visible }"
      @click.stop=""
    >
      <template v-for="(item, index) in items">
        <div v-if="index < 5" :key="item.id" :class="get_class(item)" @click="view(item.id)">
          <i class="notification-item__icon"></i>
          <div class="notification-item__text">
            <render-body :item="item" />
          </div>
        </div>
      </template>

      <div class="notification-item justify-content-end">
        <router-link :to="{ name: 'notify.notification.index' }" class="text-uppercase">
          {{ $t('notify.notification.button.see_all') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { directive as clickOutside } from 'v-click-outside-x';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import RenderBody from '@notify/components/notifications/notifications-render-body';

  export default {
    directives: { clickOutside },
    components: { RenderBody },
    data: () => ({
      is_visible: false
    }),

    computed: {
      ...mapGetters('notify/notifications/last', {
        items: DATA
      }),

      new_items_count: function() {
        const items = this.items || [];
        const new_items = items.filter(item => item.is_received !== true);

        return new_items.length;
      }
    },

    watch: {
      is_visible: function(newVal, oldVal) {
        if (newVal === false && oldVal === true) {
          this.readAllLocal();
        }
      },

      $route: function() {
        this.is_visible = false;
      }
    },

    methods: {
      ...mapActions('notify/notifications/last', ['readOne', 'readAllLocal', 'readAllServer']),

      hide: function() {
        this.is_visible = false;
      },

      open: function() {
        this.is_visible = true;
        this.readAllServer();
      },

      view: function(id) {
        this.readOne(id);
      },

      get_class: function(item) {
        return [
          'notification-item',
          'notification-item--' + item.theme,
          {
            'notification-item--new': !item.is_received
          }
        ];
      }
    }
  };
</script>

<style lang="scss">
  $border-color: #c5c5c5;

  .notifications {
    position: relative;

    &__icon {
      width: 80px;
      height: 100%;
      background-image: url('/img/icons/header/notifications.svg');
      background-repeat: no-repeat;
      background-position: center;
      position: relative;

      &:hover {
        cursor: pointer;
        background-color: $blue-grey;
      }
    }

    &__counter {
      border-radius: 50%;
      position: absolute;
      top: 18px;
      right: 24px;
      background-color: $red;
      width: 18px;
      height: 18px;
      font-size: 12px;
      font-style: normal;
      text-align: center;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__box {
      width: 350px;
      display: none;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      position: absolute;
      right: 0px;
      top: 75px;
      background-color: #ffffff;
      border: solid 1px $border-color;
      border-radius: 5px;
      z-index: 99;

      &--active {
        display: block;
      }

      &:after,
      &:before {
        right: 29px;
        bottom: 100%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(136, 183, 213, 0);
        border-bottom-color: #fff;
        border-width: 10px;
        margin-top: 10px;
      }

      &:before {
        border-color: rgba(194, 225, 245, 0);
        border-bottom-color: $border-color;
        border-width: 12px;
        right: 27px;
      }
    }

    .notification-item {
      border-bottom: solid 1px $grey-dark;
      display: flex;
      align-items: center;

      &__text {
        width: 100%;
        font-size: 14px;
        color: $blue-grey-dark;
        padding-top: 15px;
        padding-bottom: 15px;
        padding-right: 15px;
        text-align: left;
      }

      &__icon {
        display: inline-block;
        width: 32px;
        height: 20px;
        margin: auto 14px;
        background-repeat: no-repeat;
        background-size: 20px;
      }

      &--new {
        background-color: #e9f6fe;
      }

      @each $type in 'default', 'info', 'success', 'warning' {
        &--#{$type} {
          .notification-item__icon {
            background-image: url('/img/icons/notifications/#{$type}.svg');
          }
        }
      }

      &--danger,
      &--error {
        .notification-item__icon {
          background-image: url('/img/icons/notifications/danger.svg');
        }
      }

      &:first-of-type {
        border-radius: 4px 4px 0 0;
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
        padding: 15px;
      }
    }
  }
</style>
